import { TextBlockWrap, TitleText, Button, Wrapper, ButtonWrap, ImageBlock, DescriptionText } from './styled';
import { ICrashScreen } from './types';

const defaultTranslation = {
  crashScreenTitle: "Seems like something isn't working",
  crashScreenDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  crashScreenRestoreBtn: 'Restore',
  crashScreenRefreshBtn: 'Reload',
};

const CrashScreen = ({ show, onRestore, backgroundImage }: ICrashScreen) => {
  const refresh = () => {
    window.location.reload();
  };
  if (!show) return null;
  const { crashScreenTitle, crashScreenRestoreBtn, crashScreenRefreshBtn, crashScreenDescription } = defaultTranslation;
  return (
    <Wrapper backgroundImage={backgroundImage}>
      <ImageBlock />

      <TextBlockWrap>
        <TitleText className="titleText">{crashScreenTitle}</TitleText>
        <DescriptionText>{crashScreenDescription}</DescriptionText>
      </TextBlockWrap>
      <ButtonWrap>
        {onRestore && (
          <Button className="mb-2" onClick={onRestore}>
            {crashScreenRestoreBtn}
          </Button>
        )}
        <Button className="mb-2" onClick={refresh}>
          {crashScreenRefreshBtn}
        </Button>
      </ButtonWrap>
    </Wrapper>
  );
};

export default CrashScreen;
